import { put, select } from "redux-saga/effects";
import { getHubspotStatusFailure, getHubspotStatusSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* handleGetHubspotStatus() {
    try {
        const formId: string = yield select(state => state.forms.current._id);

        const { data } = yield IntegrationService.getHubspotStatus(formId);

        yield put(
            getHubspotStatusSuccess({
                success: data.success,
                message: data.message,
                data: data.data,
            }),
        );
        return data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to get Hubspot status";
        yield put(getHubspotStatusFailure(errorMessage));
    }
}
